import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class CessionnaireContainer extends ShadowDOMElement {
	static className = "CessionnaireContainer";
	
	firstUpdated() {
		super.firstUpdated();
		const selectField = this.shadowRoot.querySelector ('select-field');
		if (selectField){
			selectField.value = '1';
			this.handleSelectChange({ target: { value: '1' } });
		}
	}

	render() {
    return html`
      <div>
        <title-field label="Céssionnaire" value="1"></title-field>
        <row-wrapper>
          <select-field @change="${this.handleSelectChange}" name="id_assignee_type">
            <option-component
              label="Personne physique déjà immatriculée au RCS"
              value="1"
            ></option-component>
            <option-component
              label="Personne physique non inscrite au RCS"
              value="2"
            ></option-component>
            <option-component
              label="Société en cours de constitution"
              value="3"
            ></option-component>
            <option-component
              label="Société déjà immatriculée"
              value="4"
            ></option-component>
          </select-field>
        </row-wrapper>
        
        <personne-physique style="display: none;"></personne-physique>
        
        <personne-morale show-capital="true" style="display: none;"></personne-morale>

        <div-container id="rcs-container" visible="false">
          <rcs-number-field></rcs-number-field>
          <row-wrapper>
            <text-field label="Greffe *" required name="greffe"></text-field>
          </row-wrapper>
        </div-container>
      </div>
    `;
	}

	handleSelectChange(event) {
		const selectedValue = event.target.value;
		const personnePhysique = this.shadowRoot.querySelector('personne-physique');
		const personneMorale = this.shadowRoot.querySelector('personne-morale');
		const rcsContainer = this.shadowRoot.querySelector('#rcs-container');

		personnePhysique.style.display = 'none';
		personneMorale.style.display = 'none';
		rcsContainer.visible = false;

		switch (selectedValue) {
			case '1':
				personnePhysique.style.display = 'block';
				rcsContainer.visible = true;
				break;
			case '2':
				personnePhysique.style.display = 'block';
				rcsContainer.visible = false;
				break;
			case '3':
				personneMorale.style.display = 'block';
				rcsContainer.visible = false;
				break;
			case '4':
				personneMorale.style.display = 'block';
				rcsContainer.visible = true;
				break;
		}
	}
	
	isTransient (){
		return false;
	}
}

customElements.define('cessionnaire-container', CessionnaireContainer);
